import * as React from 'react';
import {
	EditButton,
	Identifier,
	Labeled, Record,
	RecordMap,
	TextField,
	UrlField
} from 'react-admin';
import { Card, CardContent, CardHeader } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { TranslateField } from '../components/TranslateField';
import TimeField from "../components/TimeField";

const useListStyles = makeStyles(theme => ({
	card: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		margin: '1.5rem 0',
		boxShadow: '0px 15px 20px #27313f0c !important',
		backgroundColor: 'white'
	},
	cardTitleContent: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between'
	},
	cardContent: theme.typography.body1,
	cardContentRow: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		margin: '0.5rem 0',
		fontWeight: 'bold'
	}
}));

interface LiveTrainingListProps {
	ids?: Identifier[];
	data?: RecordMap<Record>;
	basePath?: string;
}

export const LiveTrainingList = (props: LiveTrainingListProps) => {
	const { ids, data, basePath } = props;
	const classes = useListStyles();

	if (!ids || !data || !basePath) {
		return null;
	}

	return (
		<div style={{ margin: '1em', backgroundColor: '#F8F9FC' }} className="list-container">
			{ids.map(id => (
				<Card key={id} className={classes.card}>
					<CardHeader
						title={
							<div className={classes.cardTitleContent}>
                                <span>
                                    {data[id].name}
                                </span>
								<EditButton
									resource="live-trainings"
									basePath={basePath}
									record={data[id]}
								/>
							</div>
						}
					/>
					<CardContent className={classes.cardContent}>
						<Labeled label="#" className={classes.cardContentRow}>
							<TextField record={data[id]} source="id" label="#"/>
						</Labeled>
						<Labeled label="TITLE" className={classes.cardContentRow}>
							<TextField record={data[id]} source="title" label="TITLE"/>
						</Labeled>
						<Labeled label="DAY" className={classes.cardContentRow}>
							<TranslateField source="dayOfWeek" label="DAY"/>
						</Labeled>
						<Labeled label="START_HOUR" className={classes.cardContentRow}>
							<TimeField record={data[id]} source="startHour" label="START_HOUR"/>
						</Labeled>
						<Labeled label="END_HOUR" className={classes.cardContentRow}>
							<TimeField record={data[id]} source="startHour" label="END_HOUR"/>
						</Labeled>
						<Labeled label="LINK" className={classes.cardContentRow}>
							<UrlField record={data[id]} source="link" label="LINK"/>
						</Labeled>
						<Labeled label="LANGUAGE" className={classes.cardContentRow}>
							<TranslateField record={data[id]} source="language" label="LANGUAGE"/>
						</Labeled>
					</CardContent>
				</Card>
			))}
		</div>
	);
};
